import { createSlice } from '@reduxjs/toolkit';
import { SearchFiltersType } from 'app/search/global/type';

interface GlobalSearchSliceState {
    filters: SearchFiltersType | null;
    query: string | null;
    waitingConcierge: boolean;
    paramsApplied: boolean;
}

const initialState = {
    filters: {},
    query: '',
    waitingConcierge: false,
    paramsApplied: true,
} as GlobalSearchSliceState;

export const globalSearchSlice = createSlice({
    name: 'globalSearch',
    initialState,
    reducers: {
        setSearchFilters: (state, action) => {
            state.filters = action.payload as Partial<SearchFiltersType>;
        },
        setQueryString: (state, action) => {
            state.query = action.payload;
        },
        setWaitingConcierge: (state, action) => {
            state.waitingConcierge = action.payload;
        },
        setParamsApplied: (state, action) => {
            state.paramsApplied = action.payload;
        },
    },
});

export const { setSearchFilters, setQueryString, setWaitingConcierge, setParamsApplied } = globalSearchSlice.actions;

export default globalSearchSlice.reducer;
